"use client";

interface MetricCardProps {
  label: string;
  value: string | number;
  subtitle?: string;
  trend?: "up" | "down" | "neutral";
  trendValue?: string;
}

export default function MetricCard({ label, value, subtitle, trend, trendValue }: MetricCardProps) {
  return (
    <div className="bg-[var(--color-card)] border border-[var(--color-border)] rounded-lg p-4 hover:border-[var(--color-border-light)] transition-colors">
      <p className="text-[10px] uppercase tracking-widest text-[var(--color-muted)] mb-2">
        {label}
      </p>
      <div className="flex items-end gap-2">
        <p className="text-2xl font-bold text-[var(--color-foreground)] tabular-nums">
          {typeof value === "number" ? value.toFixed(2) : value}
        </p>
        {trend && trendValue && (
          <span
            className={`text-xs mb-1 ${
              trend === "down" ? "text-[var(--color-success)]" : trend === "up" ? "text-[var(--color-danger)]" : "text-[var(--color-muted)]"
            }`}
          >
            {trend === "down" ? "\u2193" : trend === "up" ? "\u2191" : "\u2014"} {trendValue}
          </span>
        )}
      </div>
      {subtitle && (
        <p className="text-[11px] text-[var(--color-muted)] mt-1">{subtitle}</p>
      )}
    </div>
  );
}
